// extracted by css-extract-rspack-plugin
export default {"container":"dQUYZCVO3ID5IGQv","note":"UtDM6a61Ung2WOiv"};